/* istanbul ignore file */

export class SiteTemplate {
    id = "";
    active = true;
    name = "";
    description = "";
    projectId = "";
    createdBy = "";
    data: { [key: string]: any; } = {};
    dateCreated?: Date;
    dateLastModified?: Date;
}
